/**
 * Build react-select staff options from merchant users.
 * Only active users are selectable; inactive users already on a store are shown for removal.
 */
export function buildMerchantStaffSelectState(allUsers, existingStaff = []) {
  const activeUsers = (allUsers || []).filter((user) => user.active !== false);
  const userById = new Map(
    (allUsers || []).map((user) => [String(user._id), user])
  );

  const staffOptions = activeUsers.map((user) => ({
    value: user._id,
    label: `${user.firstName} ${user.lastName}`.trim(),
    isDisabled: false,
  }));

  const activeOptionIds = new Set(staffOptions.map((option) => String(option.value)));
  const existing = Array.isArray(existingStaff) ? existingStaff : [];

  const storeStaffs = existing
    .map((entry) => {
      const id = String(entry?.value ?? "");
      const user = userById.get(id);
      const isInactive = user && user.active === false;

      if (activeOptionIds.has(id)) {
        return {
          value: entry.value,
          label: entry.label || `${user?.firstName || ""} ${user?.lastName || ""}`.trim(),
        };
      }

      if (isInactive) {
        return {
          value: entry.value,
          label: `${entry.label || `${user.firstName} ${user.lastName}`.trim()} (Inactive — remove)`,
          isInactive: true,
        };
      }

      return {
        value: entry.value,
        label: `${entry.label || "Unknown user"} (Missing — remove)`,
        isInactive: true,
      };
    })
    .filter((entry) => entry.value);

  return { staffOptions, storeStaffs };
}

export function getDuplicateMerchantUserEmails(users) {
  const counts = new Map();
  for (const user of users || []) {
    const email = (user.email || "").trim().toLowerCase();
    if (!email) continue;
    counts.set(email, (counts.get(email) || 0) + 1);
  }
  return new Set(
    [...counts.entries()].filter(([, count]) => count > 1).map(([email]) => email)
  );
}
